import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../common/Globals';

@Injectable()
export class HelperService {
    
    loggedUsername: string;
    isMobile: boolean;
    @Output() 
    onLoading: EventEmitter<boolean> = new EventEmitter<boolean>();
    constructor() {
        this.loggedUsername = localStorage.getItem('gesActiveUser'); 
        this.isMobile = window.screen.width < 576;
    }
}